import { PropsWithChildren, JSX, useState } from 'react';
import { DirectionalIcon, IconDirection } from '@bg-components/Icon';
import classNames from 'classnames';
import { useAfterUpdate } from '@betgames/bg-tools';
import { ListItem } from '../ListItem';
import classes from './AccordionListItem.module.scss';

interface IProps {
    label: string;
    disabled?: boolean;
    dataQa?: string;
}

export const AccordionListItem = (props: PropsWithChildren<IProps>): JSX.Element => {
    const [isOpened, setOpen] = useState<boolean>(false);
    const direction = isOpened ? IconDirection.UP : IconDirection.DOWN;

    useAfterUpdate(() => {
        if (props.disabled) {
            setOpen(false);
        }
    }, [props.disabled]);

    return (
        <>
            <ListItem
                className={classNames({
                    [classes.isOpened]: isOpened,
                })}
                label={props.label}
                dataQa={props.dataQa}
                disabled={props.disabled}
                onClick={() => {
                    setOpen(!isOpened);
                }}
            >
                <DirectionalIcon
                    className={classes.icon}
                    direction={direction}
                    dataQa={`area-accordion-item-arrow-${direction}`}
                />
            </ListItem>
            {isOpened && <div data-qa="area-accordion-item-content">{props.children}</div>}
        </>
    );
};
